// Code originally from https://codepen.io/OfigenusMaximus/pen/oNyoORG
import React from "react";
import "./Fire.css";
import Log from "./Log";
import Spark from "./Spark";
import Stick from "./Stick";

export default function CampFire() {
  return (
    <div className="campfire">
      <div className="sparks">
        {[...Array(8)].map((_, i) => (
          <Spark index={i} key={i} />
        ))}
      </div>

      <div className="logs">
        {[...Array(7)].map((_, i) => (
          <Log index={i} key={i} />
        ))}
      </div>

      <div className="sticks">
        {[...Array(4)].map((_, i) => (
          <Stick index={i} key={i} />
        ))}
      </div>
      <div className="fire">
        <div className="fire__red">
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
        </div>
        <div className="fire__orange">
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
        </div>
        <div className="fire__yellow">
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
        </div>
        <div className="fire__white">
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
          <div className="flame"></div>
        </div>
      </div>
    </div>
  );
}
